"use client";

import { useState } from "react";
import { getDownloadUrl, ResourceCategory, TrainingFile, trainingFiles } from "app/resources/src/TrainingLibraryModal/trainingFiles";
import DownloadIcon from "components/icons-svg/DownloadIcon";
import CVAModal from "components/modals/common/CVAModal";
type TrainingLibraryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  category: ResourceCategory;
};
const TrainingLibraryModal = ({
  isOpen,
  onClose,
  title,
  category
}: TrainingLibraryModalProps) => {
  const [selectedFile, setSelectedFile] = useState<TrainingFile | null>(null);
  const files = trainingFiles.filter(file => file.category === category);
  return <CVAModal isOpen={isOpen} onClose={onClose} intent='modal' size='extraLarge2' className='relative !max-w-[1400px] !p-0' modalOverlayColor='bg-[rgba(0,0,0,0.60)]' classNameCloseIcon='text-white' data-sentry-element="CVAModal" data-sentry-component="TrainingLibraryModal" data-sentry-source-file="training-library-modal.tsx">
      <div className='flex h-[min(680px,calc(100svh-32px))] min-h-0 flex-col overflow-hidden rounded-xl border border-[#866E3F] bg-[#fffdf8] sm:h-[min(800px,calc(100svh-64px))]'>
        {/* Header */}
        <header className='flex h-[74px] shrink-0 items-center bg-[#785a20] px-5 sm:px-7'>
          <h2 className='text-sm font-medium uppercase tracking-[0.2em] text-white sm:text-base'>
            {title}
          </h2>
        </header>

        {/* Content */}
        {files.length > 0 ? <div className='grid min-h-0 flex-1 md:grid-cols-[minmax(280px,1fr)_minmax(0,1.45fr)]'>
            {/* File List */}
            <div className='min-h-0 overflow-y-auto border-b border-[#d9d2c3] md:border-b-0 md:border-r'>
              {files.map(file => {
            const isSelected = selectedFile?.name === file.name;
            return <div key={file.name} className={`flex min-h-[52px] items-center gap-3 border-b border-[#e7e1d5] px-5 text-sm ${isSelected ? "bg-[#f1eee5]" : "bg-white"}`}>
                    <button type='button' onClick={() => setSelectedFile(file)} className='min-w-0 flex-1 truncate py-3 text-left text-[#5d5b58] hover:text-[#785a20]'>
                      {file.name}
                    </button>

                    {/* Download file */}
                    {["pdf", "image", "video"].includes(file.type) && <a href={getDownloadUrl(file.url)} download aria-label={`Download ${file.name}`} className='shrink-0'>
                        <DownloadIcon className='h-5 w-4' />
                      </a>}
                  </div>;
          })}
            </div>

            {/* Preview */}
            <div className='flex min-h-0 min-w-0 bg-white'>
              <div className='flex min-h-0 flex-1 items-center justify-center p-4 sm:p-6'>
                {!selectedFile ? <div className='text-center text-[#53535D]'>
                    <p className='text-[19px] font-semibold leading-[24.7px]'>
                      File Preview
                    </p>
                    <p className='mt-2 text-[15px] leading-5'>
                      Select a file from the list to preview it here
                    </p>
                  </div> : selectedFile.type === "pdf" ? <iframe key={selectedFile.url} title={selectedFile.name} src={selectedFile.url} className='h-full min-h-[300px] w-full border-0' /> : selectedFile.type === "image" ? <div className='relative flex h-full w-full items-center justify-center'>
                    <img src={selectedFile.url} alt={selectedFile.name} className='max-h-full max-w-full object-contain' />
                  </div> : <video key={selectedFile.url} controls autoPlay playsInline preload='auto' className='h-full w-full object-contain' onError={event => {
              console.error("Video failed to load:", event.currentTarget.error, selectedFile?.url);
            }}>
                    <source src={selectedFile.url} type='video/mp4' />
                    <track kind='captions' />
                    Your browser does not support video playback.
                  </video>}
              </div>
            </div>
          </div> : ( /* Empty State */
      <div className='flex min-h-0 flex-1 items-center justify-center bg-white'>
            <div className='text-center text-[#6c6870]'>
              <p className='font-semibold'>No resources available</p>
            </div>
          </div>)}
      </div>
    </CVAModal>;
};
export default TrainingLibraryModal;